"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StatusFilter_1 = require("../models/enums/StatusFilter");
var timed_cache_1 = __importDefault(require("timed-cache"));
var cacheOptions = {
    cachingEnabled: false,
    cacheDurationInMinutes: 0,
    slidingExpirationEnabled: false
};
// Caching Setup
var cacheAll;
var cache;
var allStaffKey = "ALL_STAFF_KEY";
exports.initialize = function (options) {
    if (options) {
        cacheOptions = options;
        cacheAll = new timed_cache_1.default({ defaultTtl: 60 * 1000 * cacheOptions.cacheDurationInMinutes });
        cache = new timed_cache_1.default({ defaultTtl: 60 * 1000 * cacheOptions.cacheDurationInMinutes });
    }
};
exports.isCachingEnabled = function () {
    return cacheOptions.cachingEnabled;
};
exports.getByAzureAdOid = function (azureAdOid) {
    var key = getCacheKeyForAzureAdOid(azureAdOid);
    var cachedValue = getFromCache(key);
    if (cachedValue && cachedValue.length === 1) {
        return cachedValue[0];
    }
    return undefined;
};
exports.setByAzureAdOid = function (azureAdOid, staffMember) {
    var key = getCacheKeyForAzureAdOid(azureAdOid);
    // All items are stored as arrays - the corresponding get method will return the 1st element.
    // This allows the same cache to work for the get by Azure AD OID and the get by filter params
    cache.put(key, [staffMember]);
};
exports.getByAzureAdOids = function (azureAdOids) {
    var key = getCacheKeyForAzureAdOids(azureAdOids);
    return getFromCache(key);
};
exports.setByAzureAdOids = function (azureAdOids, staffMembers) {
    var key = getCacheKeyForAzureAdOids(azureAdOids);
    cache.put(key, staffMembers);
};
exports.getByEmailAddress = function (emailAddress) {
    var key = getCacheKeyForEmailAddress(emailAddress);
    var cachedValue = getFromCache(key);
    if (cachedValue && cachedValue.length === 1) {
        return cachedValue[0];
    }
    return undefined;
};
exports.setByEmailAddress = function (emailAddress, staffMember) {
    var key = getCacheKeyForEmailAddress(emailAddress);
    // All items are stored as arrays - the corresponding get method will return the 1st element.
    // This allows the same cache to work for the get by Email Address and the get by filter params
    cache.put(key, [staffMember]);
};
exports.getByStaffId = function (staffId) {
    var key = getCacheKeyForStaffId(staffId);
    var cachedValue = getFromCache(key);
    if (cachedValue && cachedValue.length === 1) {
        return cachedValue[0];
    }
    return undefined;
};
exports.setByStaffId = function (staffId, staffMember) {
    var key = getCacheKeyForStaffId(staffId);
    // All items are stored as arrays - the corresponding get method will return the 1st element.
    // This allows the same cache to work for the get by Staff ID and the get by filter params
    cache.put(key, [staffMember]);
};
exports.getByStaffIds = function (staffIds) {
    var key = getCacheKeyForStaffIds(staffIds);
    return getFromCache(key);
};
exports.setByStaffIds = function (staffIds, staffMembers) {
    var key = getCacheKeyForStaffIds(staffIds);
    cache.put(key, staffMembers);
};
exports.getByPartialName = function (partialName) {
    var key = getCacheKeyForPartialName(partialName);
    return getFromCache(key);
};
exports.setByPartialName = function (partialName, staffMembers) {
    var key = getCacheKeyForPartialName(partialName);
    cache.put(key, staffMembers);
};
exports.getActiveAndInactiveByPartialName = function (partialName) {
    var key = getCacheKeyForActiveAndInactivePartialName(partialName);
    return getFromCache(key);
};
exports.setActiveAndInactiveByPartialName = function (partialName, staffMembers) {
    var key = getCacheKeyForActiveAndInactivePartialName(partialName);
    cache.put(key, staffMembers);
};
exports.getByFilterCriteria = function (filterCriteria) {
    var key = getCacheKeyForFilterCriteria(filterCriteria);
    return getFromCache(key);
};
exports.setByFilterCriteria = function (filterCriteria, staffMembers) {
    var key = getCacheKeyForFilterCriteria(filterCriteria);
    cache.put(key, staffMembers);
};
exports.getAllStaff = function () {
    var cachedValue = cacheAll.get(allStaffKey);
    if (cachedValue !== undefined && cacheOptions.slidingExpirationEnabled) {
        // Slide the expiration
        cacheAll.put(allStaffKey, cachedValue);
    }
    return cachedValue;
};
exports.setAllStaff = function (staffMembers) {
    cacheAll.put(allStaffKey, staffMembers);
};
exports.clearCache = function () {
    cache.clear();
    cacheAll.clear();
};
var getFromCache = function (key) {
    var cachedValue = cache.get(key);
    if (cachedValue !== undefined && cacheOptions.slidingExpirationEnabled) {
        // Slide the expiration
        cache.put(key, cachedValue);
    }
    return cachedValue;
};
var getCacheKeyForAzureAdOid = function (azureAdOid) {
    var filterCriteria = {
        azureAdOids: [azureAdOid]
    };
    return getCacheKeyForFilterCriteria(filterCriteria);
};
var getCacheKeyForAzureAdOids = function (azureAdOids) {
    var filterCriteria = {
        azureAdOids: azureAdOids
    };
    return getCacheKeyForFilterCriteria(filterCriteria);
};
var getCacheKeyForEmailAddress = function (emailAddress) {
    var filterCriteria = {
        emailAddress: emailAddress
    };
    return getCacheKeyForFilterCriteria(filterCriteria);
};
var getCacheKeyForStaffId = function (staffId) {
    var filterCriteria = {
        staffIds: [staffId]
    };
    return getCacheKeyForFilterCriteria(filterCriteria);
};
var getCacheKeyForStaffIds = function (staffIds) {
    var filterCriteria = {
        staffIds: staffIds
    };
    return getCacheKeyForFilterCriteria(filterCriteria);
};
var getCacheKeyForPartialName = function (partialName) {
    var filterCriteria = {
        partialName: partialName
    };
    return getCacheKeyForFilterCriteria(filterCriteria);
};
var getCacheKeyForActiveAndInactivePartialName = function (partialName) {
    var filterCriteria = {
        partialName: partialName,
        status: StatusFilter_1.StatusFilter.BothActiveAndInactive
    };
    return getCacheKeyForFilterCriteria(filterCriteria);
};
var getCacheKeyForFilterCriteria = function (filterCriteria) {
    var keys = Object.keys(filterCriteria).sort();
    var sortedFilterCriteria = {};
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        var value = filterCriteria[key];
        if (value !== undefined && value !== null && value !== '') {
            if (key === "azureAdOids") {
                var currentValue = value;
                if (currentValue.length > 0) {
                    sortedFilterCriteria.azureAdOids = currentValue.sort();
                }
            }
            else if (key === "racfIds") {
                var currentValue = value;
                if (currentValue.length > 0) {
                    sortedFilterCriteria.racfIds = currentValue.sort();
                }
            }
            else if (key === "staffIds") {
                var currentValue = value;
                if (currentValue.length > 0) {
                    sortedFilterCriteria.staffIds = currentValue.sort();
                }
            }
            else if (key === "staffTypeCodes") {
                var currentValue = value;
                if (currentValue.length > 0) {
                    sortedFilterCriteria.staffTypeCodes = currentValue.sort();
                }
            }
            else if (key === "status") {
                // Active only is the default so if its explicity set its the same as if its not present
                if (value !== StatusFilter_1.StatusFilter.ActiveOnly) {
                    sortedFilterCriteria.status = value;
                }
            }
            else {
                // Non array properties need no special treatment
                sortedFilterCriteria[key] = value;
            }
        }
    }
    return JSON.stringify(sortedFilterCriteria);
};
